export const LOCALES = {
  en: { pathPrefix: 'en', locale: 'en-US', label: '🇬🇧 English' },
  'zh-hk': { pathPrefix: 'zh-hk', locale: 'zh-HK', label: '🇭🇰 繁體中文' },
} as const;

export type Lang = keyof typeof LOCALES;
export const DEFAULT_LANG: Lang = 'en';

// Helper to validate lang from URL param
export function isLang(x: any): x is Lang {
  return typeof x === 'string' && Object.keys(LOCALES).includes(x);
}

export function getLocale(lang: Lang): string {
  return LOCALES[lang].locale;
}
